<template>
  <pagefra>
    <div class="riskConfirmLog container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('用户')">
              <el-input
                v-model="form.username"
                :placeholder="$l('用户')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('确认时间')">
              <el-date-picker
                v-model="confirmTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('确认开始时间')"
                :end-placeholder="$l('确认结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('用户')"
              prop="username"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('确认时间')"
              prop="confirmTime"
              align="center"
              min-width="200"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "riskConfirmLog",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        username: "",
        startConfirmTime: null,
        endConfirmTime: null,
      },
      confirmTimeValues: [],
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.confirmTimeValues && this.confirmTimeValues.length == 2) {
        this.form.startConfirmTime = this.$common.formatDateTime(
          this.confirmTimeValues[0]
        );
        this.form.endConfirmTime = this.$common.formatDateTime(
          this.confirmTimeValues[1]
        );
      } else {
        this.form.startConfirmTime = null;
        this.form.endConfirmTime = null;
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_risk_confirm_log_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.riskConfirmLog {
}
</style>
